import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PaymentEditCreditCard from './PaymentEditCreditCard';
import PaymentTelmexMexicoGate from './PaymentTelmexMexicoGate';
import { converter } from '../../../helpers/converter';
import * as actionsUser from '../../../action-creators/user';
import Utils from '../../../utils/Utils';
import { payWaySelector } from '../MyAccountSelector';

export class PaymentEditMode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentForm: null,
    };

    this.setPayment = this.setPayment.bind(this);
  }

  setPayment(paymentMethod) {
    this.setState({ currentForm: paymentMethod });
  }

  updateData = () => {
    this.props.viewFunction();
    this.props.fetchPaywayData(this.props.config);
  }

  renderPaymentForm() {
    const { payway, translations } = this.props;
    const suscDefaultText = converter.convertApaUnicode(
      translations,
      'no_payment_method',
      'Aún no se ha asociado un método de pago',
    );

    if (payway.list.length == 0) {
      return <div>{suscDefaultText}</div>;
    }

    const payment = Utils.filterPaywayData(payway.list);

    const paymentMethod =
      this.state.currentForm || payment.purchase_data.gateway;

    if (
      !this.state.currentForm &&
      this.props.values &&
      this.props.values.response &&
      this.props.values.response.paymethodValues &&
      payment.purchase_data &&
      payment.purchase_data.gateway_data
    ) {
      this.props.values.response.paymethodValues.name =
        payment.purchase_data.gateway_data.card_owner_name;

      this.props.values.response.paymethodValues.cardNumber = payment.purchase_data.gateway_data.card_number_display.replace(
        /\s/g,
        '',
      );
      this.props.values.response.paymethodValues.address =
        payment.purchase_data.gateway_data.address;
      this.props.values.response.paymethodValues.city =
        payment.purchase_data.gateway_data.city;
      this.props.values.response.paymethodValues.states =
        payment.purchase_data.gateway_data.state;
      this.props.values.response.paymethodValues.zipCode =
        payment.purchase_data.gateway_data.zip_code;
      this.props.values.response.paymethodValues.telefono =
        payment.purchase_data.gateway_data.phone_number;
      this.props.values.response.paymethodValues.cardType =
        payment.purchase_data.gateway_data.card_type;
      this.props.values.response.paymethodValues.expiryDate_MM = parseInt(
        payment.purchase_data.gateway_data.expiration_month,
        10,
      );
      this.props.values.response.paymethodValues.expiryDate_YY =
        payment.purchase_data.gateway_data.expiration_year;
      const bDate = payment.purchase_data.gateway_data.birth_date.split
        ? payment.purchase_data.gateway_data.birth_date.split('/')
        : ['30', '01', '1985'];
      this.props.values.response.paymethodValues.dateOfBirth_DD = bDate[0];
      this.props.values.response.paymethodValues.dateOfBirth_MM = bDate[1];
      this.props.values.response.paymethodValues.dateOfBirth_YY = bDate[2];

      // error de api falta fix...
      if (
        payment.purchase_data.gateway_data.expiration_month.length == 4 &&
        payment.purchase_data.gateway_data.expiration_year.length == 2
      ) {
        this.props.values.response.paymethodValues.expiryDate_MM = parseInt(
          payment.purchase_data.gateway_data.expiration_year,
        );
        this.props.values.response.paymethodValues.expiryDate_YY =
          payment.purchase_data.gateway_data.expiration_month;
      } else {
        this.props.values.response.paymethodValues.expiryDate_MM = parseInt(
          payment.purchase_data.gateway_data.expiration_month,
        );
        this.props.values.response.paymethodValues.expiryDate_YY =
          payment.purchase_data.gateway_data.expiration_year;
      }
    }
    switch (paymentMethod) {
      case 'plazavipgate':
        return (
          <PaymentEditCreditCard
            translations={this.props.translations}
            changeToViewMode={this.props.changeToViewMode}
            states={this.props.states}
            formValues={this.props.values.response.paymethodValues}
            setPayment={this.setPayment}
            updateData={this.updateData}
          />
        );
      case 'telmexmexicogate':
        return (
          <PaymentTelmexMexicoGate
            translations={this.props.translations}
            changeToViewMode={this.props.changeToViewMode}
            states={this.props.states}
            setPayment={this.setPayment}
            updateData={this.updateData}
          />
        );
      default:
        return <div>{suscDefaultText}</div>;
    }
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h3>
              <strong>Modificar medio de pago</strong>
            </h3>
          </div>
        </div>
        {this.renderPaymentForm()}
      </div>
    );
  }
}

PaymentEditMode.propTypes = {
  payway: PropTypes.shape({}),
  states: PropTypes.shape({}),
  changeToViewMode: PropTypes.func,
  translations: PropTypes.shape({}).isRequired,
  viewFunction: PropTypes.func,
  fetchPaywayData: PropTypes.func,
  config: PropTypes.func,
  values: PropTypes.shape({
    response: PropTypes.shape({
      paymethodValues: PropTypes.shape({
        address: PropTypes.string,
        city: PropTypes.string,
        states: PropTypes.string,
        zipCode: PropTypes.string,
        telefono: PropTypes.string,
        cardType: PropTypes.string,
        expiryDate_MM: PropTypes.string,
        expiryDate_YY: PropTypes.string,
        name: PropTypes.string,
        cardNumber: PropTypes.string,
      }),
    }),
  }),
};

const mapStateToProps = state => ({
  translations: state.translations,
  config: state.config,
  payway: payWaySelector(state),
});

const mapDispatchToProps = dispatch => ({
  fetchPaywayData(config) {
    dispatch(actionsUser.fetchPaywayData(config));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentEditMode);
